import config from "../config";
import { toCalendarDate, formatter } from "../shared/dateTimeUtils";
import { MODULE_NAME } from "shared/moduleIds";

export const transformPatient = (p, { moduleId, isBaselineWorklist } = {}) => {
  if (!p) return;

  // AS1-4999 For all "patients" with a mrnState of 'MrnFixed',
  // Consider those to be "empty beds" when isActive is false
  if (p.mrnState === "MrnFixed" && p.status === "inactive") {
    p.isEmptyBed = true;
  }

  p.moduleSpecificData?.forEach((m) => {
    p[MODULE_NAME[m.moduleId]] = m;
  });
  p.moduleSpecifics = moduleSpecifics(p, moduleId);
  if (p.dateOfBirth) {
    p.calendarDateOfBirth = toCalendarDate(p.dateOfBirth);
    p.dateOfBirth = formatter.calendarDate(p.calendarDateOfBirth);
  }

  if (isBaselineWorklist) {
    p.groupId = p.groupId || p.moduleSpecifics?.unit;
  }
  if (config.hidePHI) {
    p.lastName = p.lastName[0];
    p.firstName = p.firstName[0];
  }
  return p;
};

function moduleSpecifics(patient, moduleId = sessionStorage.moduleId) {
  return patient?.moduleSpecificData?.find(
    (spec) => spec.moduleId.toString() === String(moduleId),
  );
}
